import axios from 'axios'
import { errorHandler } from '../exports/error_management'

const state = {
    item: null,
    items: [],
    options: {},
}

/*
{"entities":{"Internal":0,"Customer":1,"Officer":2},"flows":{"Shrinkage":0,"Outbound":1,"Inbound":2,"None":3}}
*/
const getters = {
    flowOptions(state) {
        const flows = (state.options || {}).flows || {}
        return (
            Object.keys(flows).map(key => ({
                value: flows[key],
                text: key,
            })) || []
        )
    },
    entityOptions(state) {
        console.log('transactionType options', state.options)
        const entities = (state.options || {}).entities || {}
        return (
            Object.keys(entities).map(key => ({
                value: entities[key],
                text: key == 'Black Hole' ? 'None' : key,
            })) || []
        ).filter(x => x.value !== -1)
    },
    referenceEntityOptions(state) {
        const entities = (state.options || {}).entities || {}
        return (
            Object.keys(entities).map(key => ({
                value: entities[key],
                text: key == 'Black Hole' ? 'None' : key,
            })) || []
        ).filter(x => x.text !== 'Officer')
    },
    flows(state) {
        return (state.options || {}).flows || {}
    },
    entities(state) {
        return (state.options || {}).entities || {}
    },
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_options(state, payload) {
        state.options = payload
    },
}

const actions = {
    async create({ dispatch }, payload) {
        try {
            await axios.post(`transaction_type`, payload)
            dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById({ commit }, id) {
        try {
            const {
                data: {
                    success: { data },
                },
            } = await axios.get(`transaction_type/${id}`)
            console.log('fetch item', data)
            commit('set_item', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll({ commit, dispatch }) {
        try {
            await dispatch('fetchOptions')
            const {
                data: {
                    success: { data },
                },
            } = await axios.get(`transaction_type`)
            console.log('fetchall', data)
            commit('set_items', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchOptions({ commit }) {
        try {
            const {
                data: {
                    success: { data },
                },
            } = await axios.get(`transaction_type/options`)
            console.log('fetchall', data)
            commit('set_options', JSON.parse(data))
        } catch (err) {
            errorHandler(err)
        }
    },

    async update({ dispatch }, payload) {
        console.log('update', payload)
        try {
            await axios.put(`transaction_type/${payload.id}`, payload)
            dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete({ dispatch }, id) {
        try {
            await axios.delete(`transaction_type/${id}`)
            dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
